import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link as ScrollLink } from "react-scroll";

const FooterSection: React.FC = () => {
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <footer className="section agency-footer pb-5">
        <Container>
          <Row>
            <Col lg={4} md={4}>
              <div>
                <h6
                  className="footer-heading text-uppercase fw-bold f-16"
                  style={{
                    marginRight: "33px",
                  }}
                >
                  {t("footer.information")}
                </h6>
                <ul className="list-unstyled footer-link mt-3 mb-0">
                  <li
                  
                    style={{
                      cursor: "pointer",
                    }}
                  >
                    <ScrollLink smooth={true} duration={500} to="home">
                      {t("navbar.home")}
                    </ScrollLink>
                  </li>
                  <li   style={{
                      cursor: "pointer",
                    }}>
                    <ScrollLink smooth={true} duration={500} to="about">
                      {t("navbar.about")}
                    </ScrollLink>
                  </li>
                  <li   style={{
                      cursor: "pointer",
                    }}>
                    <ScrollLink smooth={true} duration={500} to="services">
                      {t("navbar.services")}
                    </ScrollLink>
                  </li>
                  <li   style={{
                      cursor: "pointer",
                    }}>
                    <ScrollLink smooth={true} duration={500} to="work">
                      {t("navbar.work")}
                    </ScrollLink>
                  </li>
                </ul>
              </div>
            </Col>
            <Col lg={4}>
              <div>
                <h6 className="footer-heading text-uppercase fw-bold f-16">
                  {t("footer.contact")}
                </h6>
                <ul className="list-unstyled p-0 footer-link mt-3 mb-0">
                  <li dir="ltr">
                    <a href="tel:+966510731221">+966510731221</a>
                  </li>
                  <li>
                    <a href="mailto:Ssaammtt60@gmail.com">
                      Ssaammtt60@gmail.com
                    </a>
                  </li>
                </ul>
              </div>
            </Col>

            <Col lg={4}>
              <div>
                <h6 className="footer-heading text-uppercase fw-bold f-13">
                  {t("footer.subscribeNow")}
                </h6>

                <div className="mt-4 text-center mx-auto">
                  <div className="agency-footer-subcribe">
                    <form action="#">
                      <input
                        placeholder={t("footer.emailPlaceholder")}
                        type="text"
                      />
                      <button type="submit" className="btn btn-custom">
                        <i className="mdi mdi-airplane"></i>
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </Col>
          </Row>

          <Row className="mt-5">
            <Col lg={4}>
              <div className="agency-footer-alt-content p-4">
                <p className="copy-right text-center mb-0">
                  {t("footer.copyRight")} {new Date().getFullYear()}{" "}
                  {t("footer.designBy")}
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  );
};

export default FooterSection;
